<template>
  <div class="loading_container">
      <div class="loader">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>

  </div>
</template>

<script>
export default {
  methods: {
    
  },
    props: {
      status: {
          type: String,
          default: ""
      }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$dots: 3;
$ease: ease-out;
$speed: 800ms;
$delay: .1;
$size: 10px;
$spacing: $size / 2;
$distance: 200%;
$color: #cdb1ff;

.loading_container {
  //  background: url('/assets/bg_green.jpg');
  //  background-size: cover;
   height: 60px;
  //  display: flex;
  //  justify-content: center;
  //  align-items: center;
}

.loader {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.dot {
  margin-left: $spacing;
  margin-right: $spacing;
  width: $size;
  height: $size;
  background-color: $color;
  border-radius: 50%;
  animation: loader $speed $ease infinite;
  
  @for $i from 1 through $dots {
    &:nth-child(#{$i}) {
      animation-delay: #{$i * $delay}s;
    }
  }  
}

@keyframes loader {
  0%, 100%{
    transform: translateY(0);
  }
    
  50% {
    transform: translateY($distance);
  }
}

</style>
